<h2 matDialogTitle>So bekommst du einen Zugang</h2>

<mat-dialog-content>
  @let link = benutzerverwaltungLink;
  <p class="einleitung mat-body-medium">
    Du kannst dich hier nicht selbst registrieren. Zugänge zu SaniUp ONE legt dein Sanitätshaus selbst an.
  </p>

  <h3 class="mat-title-small">Das macht eine Kollegin oder ein Kollege mit Zugang</h3>
  <ol class="schritte mat-body-medium">
    <li>In SaniUp ONE oben rechts auf das Zahnrad klicken. Das sind die Einstellungen.</li>
    <li>Den Reiter <span class="pfad">Benutzer:innen</span> öffnen.</li>
    <li>Auf <span class="pfad">Zugang anlegen</span> klicken. Dort kommen deine E-Mail-Adresse, eine Rolle und ein Passwort hinein.</li>
  </ol>

  <p class="fussnote icon-text mat-body-small">
    <mat-icon>key</mat-icon>
    <span>Du bekommst dazu keine E-Mail von SaniUp. Das Passwort gibt dir die Kollegin oder der Kollege weiter.</span>
  </p>

  <h3 class="mat-title-small">Zum Weiterschicken</h3>
  <div class="feld">
    <span class="mat-label-small fussnote">Link zur Benutzerverwaltung</span>
    <div class="feld__zeile">
      <span class="feld__wert mat-body-medium">{{ link }}</span>
      <lib-copy-button [content]="link" [small]="true" />
    </div>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="email-feld">
    <mat-label>Deine E-Mail-Adresse</mat-label>
    <input matInput type="email" autocomplete="email" data-browser-autofill [value]="eigeneEmail()" (input)="emailEingeben($event)" />
    <mat-hint>Kommt in die Nachricht. Mit dieser Adresse meldest du dich später an.</mat-hint>
  </mat-form-field>

  <button
    type="button"
    matButton="filled"
    class="nachricht-knopf"
    [cdkCopyToClipboard]="nachricht()"
    (cdkCopyToClipboardCopied)="nachrichtKopiert($event)"
  >
    <mat-icon>content_copy</mat-icon>
    Fertige Nachricht kopieren
  </button>
  <p class="mat-body-small fussnote">Kopiert eine kurze Nachricht mit allem, was die Kollegin oder der Kollege dafür braucht.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" matButton matDialogClose>Schließen</button>
</mat-dialog-actions>
